export default {
  AE: {
    postcode: {
      required: false,
      hidden: true,
      type: 'number'
    },
    state: {
      required: false
    },
    phone: {
      hidden: true
    }
  },
  AF: {
    state: {
      required: false,
      hidden: true
    },
    phone: {
      hidden: true
    }
  },
  AL: {
    state: {
      label: 'County'
    },
    phone: {
      hidden: true
    }
  },
  AO: {
    postcode: {
      required: false,
      hidden: true,
      type: 'number'
    },
    state: {
      label: 'Province'
    },
    phone: {
      hidden: true
    }
  },
  AT: {
    postcode: {
      priority: 65,
      type: 'number'
    },
    state: {
      required: false,
      hidden: true
    },
    phone: {
      hidden: true
    }
  },
  AU: {
    city: {
      label: 'Suburb'
    },
    postcode: {
      label: 'Postcode',
      type: 'number'
    },
    state: {
      label: 'State'
    },
    phone: {
      hidden: true
    }
  },
  AX: {
    postcode: {
      priority: 65,
      type: 'number'
    },
    state: {
      required: false,
      hidden: true
    },
    phone: {
      hidden: true
    }
  },
  BD: {
    postcode: {
      required: false,
      type: 'number'
    },
    state: {
      label: 'District'
    },
    phone: {
      hidden: true
    }
  },
  BE: {
    postcode: {
      priority: 65,
      type: 'number'
    },
    state: {
      required: false,
      hidden: true
    },
    phone: {
      hidden: true
    }
  },
  BG: {
    state: {
      required: false
    },
    phone: {
      hidden: true
    }
  },
  BH: {
    postcode: {
      required: false,
      type: 'number'
    },
    state: {
      required: false,
      hidden: true
    },
    phone: {
      hidden: true
    }
  },
  BI: {
    state: {
      required: false,
      hidden: true
    },
    phone: {
      hidden: true
    }
  },
  BO: {
    postcode: {
      required: false,
      hidden: true,
      type: 'number'
    },
    state: {
      label: 'Department'
    },
    phone: {
      hidden: true
    }
  },
  BS: {
    postcode: {
      required: false,
      hidden: true,
      type: 'number'
    },
    phone: {
      hidden: true
    }
  },
  BZ: {
    postcode: {
      required: false,
      hidden: true,
      type: 'number'
    },
    state: {
      required: false
    },
    phone: {
      hidden: true
    }
  },
  CA: {
    postcode: {
      label: 'Postal code',
      type: 'text'
    },
    state: {
      label: 'Province'
    },
    phone: {
      hidden: true
    }
  },
  CH: {
    postcode: {
      priority: 65,
      type: 'number'
    },
    state: {
      label: 'Canton',
      required: false
    },
    phone: {
      hidden: true
    }
  },
  CL: {
    city: {
      required: true
    },
    postcode: {
      required: false,
      hidden: false,
      type: 'number'
    },
    state: {
      label: 'Region'
    },
    phone: {
      hidden: true
    }
  },
  CN: {
    state: {
      label: 'Province'
    },
    phone: {
      hidden: true
    }
  },
  CO: {
    postcode: {
      required: false,
      type: 'number'
    },
    state: {
      label: 'Department'
    },
    phone: {
      hidden: true
    }
  },
  CR: {
    state: {
      label: 'Province'
    },
    phone: {
      hidden: true
    }
  },
  CW: {
    postcode: {
      required: false,
      hidden: true,
      type: 'number'
    },
    state: {
      required: false
    },
    phone: {
      hidden: true
    }
  },
  CZ: {
    state: {
      required: false,
      hidden: true
    },
    phone: {
      hidden: true
    }
  },
  DE: {
    postcode: {
      priority: 65,
      type: 'number'
    },
    state: {
      required: false,
      hidden: true
    },
    phone: {
      hidden: true
    }
  },
  DK: {
    postcode: {
      priority: 65,
      type: 'number'
    },
    state: {
      required: false,
      hidden: true
    },
    phone: {
      hidden: true
    }
  },
  DO: {
    state: {
      label: 'Province'
    },
    phone: {
      hidden: true
    }
  },
  EC: {
    state: {
      label: 'Province'
    },
    phone: {
      hidden: true
    }
  },
  EE: {
    postcode: {
      priority: 65,
      type: 'number'
    },
    state: {
      required: false,
      hidden: true
    },
    phone: {
      hidden: true
    }
  },
  FI: {
    postcode: {
      priority: 65,
      type: 'number'
    },
    state: {
      required: false,
      hidden: true
    },
    phone: {
      hidden: true
    }
  },
  FR: {
    postcode: {
      priority: 65,
      type: 'number'
    },
    state: {
      required: false,
      hidden: true
    },
    phone: {
      hidden: true
    }
  },
  GG: {
    state: {
      required: false,
      label: 'Parish'
    },
    phone: {
      hidden: true
    }
  },
  GH: {
    postcode: {
      required: false,
      type: 'number'
    },
    state: {
      label: 'Region'
    },
    phone: {
      hidden: true
    }
  },
  GP: {
    state: {
      required: false,
      hidden: true
    },
    phone: {
      hidden: true
    }
  },
  GF: {
    state: {
      required: false,
      hidden: true
    },
    phone: {
      hidden: true
    }
  },
  GR: {
    state: {
      required: false
    },
    phone: {
      hidden: true
    }
  },
  GT: {
    postcode: {
      required: false,
      type: 'number'
    },
    state: {
      label: 'Department'
    },
    phone: {
      hidden: true
    }
  },
  HK: {
    postcode: {
      required: false,
      type: 'number'
    },
    city: {
      label: 'Town / District'
    },
    state: {
      label: 'Region'
    },
    phone: {
      hidden: true
    }
  },
  HN: {
    state: {
      label: 'Department'
    },
    phone: {
      hidden: true
    }
  },
  HU: {
    last_name: {
      class: ['form-row-first'],
      priority: 10
    },
    first_name: {
      class: ['form-row-last'],
      priority: 20
    },
    postcode: {
      class: ['form-row-first', 'address-field'],
      priority: 65,
      type: 'number'
    },
    city: {
      class: ['form-row-last', 'address-field']
    },
    address_1: {
      priority: 71
    },
    address_2: {
      priority: 72
    },
    state: {
      label: 'County',
      required: false
    },
    phone: {
      hidden: true
    }
  },
  ID: {
    state: {
      label: 'Province'
    },
    phone: {
      hidden: true
    }
  },
  IE: {
    postcode: {
      required: false,
      label: 'Eircode',
      type: 'text'
    },
    state: {
      label: 'County'
    },
    phone: {
      hidden: true
    }
  },
  IS: {
    postcode: {
      priority: 65,
      type: 'number'
    },
    state: {
      required: false,
      hidden: true
    },
    phone: {
      hidden: true
    }
  },
  IL: {
    postcode: {
      priority: 65,
      type: 'number'
    },
    state: {
      required: false,
      hidden: true
    },
    phone: {
      hidden: true
    }
  },
  IM: {
    state: {
      required: false,
      hidden: true
    },
    phone: {
      hidden: true
    }
  },
  IN: {
    postcode: {
      label: 'PIN Code',
      type: 'number'
    },
    state: {
      label: 'State'
    },
    phone: {
      hidden: true
    }
  },
  IT: {
    postcode: {
      priority: 65,
      type: 'number'
    },
    state: {
      required: true,
      label: 'Province'
    },
    phone: {
      hidden: true
    }
  },
  JM: {
    city: {
      label: 'Town / City / Post Office'
    },
    postcode: {
      required: false,
      label: 'Postal Code',
      type: 'text'
    },
    state: {
      required: true,
      label: 'Parish'
    },
    phone: {
      hidden: true
    }
  },
  JP: {
    last_name: {
      class: ['form-row-first'],
      priority: 10
    },
    first_name: {
      class: ['form-row-last'],
      priority: 20
    },
    postcode: {
      class: ['form-row-first', 'address-field'],
      priority: 65,
      type: 'number'
    },
    state: {
      label: 'Prefecture',
      class: ['form-row-last', 'address-field'],
      priority: 66
    },
    city: {
      priority: 67
    },
    address_1: {
      priority: 68
    },
    address_2: {
      priority: 69
    },
    phone: {
      hidden: true
    }
  },
  KN: {
    postcode: {
      required: false,
      label: 'Postal code',
      type: 'number'
    },
    state: {
      required: true,
      label: 'Parish'
    },
    phone: {
      hidden: true
    }
  },
  KR: {
    state: {
      required: false,
      hidden: true
    },
    phone: {
      hidden: true
    }
  },
  KW: {
    state: {
      required: false,
      hidden: true
    },
    phone: {
      hidden: true
    }
  },
  LV: {
    state: {
      label: 'Municipality',
      required: false
    },
    phone: {
      hidden: true
    }
  },
  LB: {
    state: {
      required: false,
      hidden: true
    },
    phone: {
      hidden: true
    }
  },
  MF: {
    state: {
      required: false,
      hidden: true
    },
    phone: {
      hidden: true
    }
  },
  MQ: {
    state: {
      required: false,
      hidden: true
    },
    phone: {
      hidden: true
    }
  },
  MT: {
    state: {
      required: false,
      hidden: true
    },
    phone: {
      hidden: true
    }
  },
  MZ: {
    postcode: {
      required: false,
      hidden: true,
      type: 'number'
    },
    state: {
      label: 'Province'
    },
    phone: {
      hidden: true
    }
  },
  NI: {
    state: {
      label: 'Department'
    },
    phone: {
      hidden: true
    }
  },
  NL: {
    postcode: {
      priority: 65,
      type: 'text'
    },
    state: {
      required: false,
      hidden: true
    },
    phone: {
      hidden: true
    }
  },
  NG: {
    postcode: {
      label: 'Postcode',
      required: true,
      hidden: false,
      type: 'number'
    },
    state: {
      label: 'State'
    },
    phone: {
      hidden: true
    }
  },
  NZ: {
    postcode: {
      label: 'Postcode',
      type: 'number'
    },
    state: {
      required: false,
      label: 'Region'
    },
    phone: {
      hidden: true
    }
  },
  NO: {
    postcode: {
      priority: 65,
      type: 'number'
    },
    state: {
      required: false,
      hidden: true
    },
    phone: {
      hidden: true
    }
  },
  NP: {
    state: {
      label: 'State / Zone'
    },
    postcode: {
      required: false,
      type: 'number'
    },
    phone: {
      hidden: true
    }
  },
  PA: {
    state: {
      label: 'Province'
    },
    phone: {
      hidden: true
    }
  },
  PL: {
    postcode: {
      priority: 65,
      type: 'number'
    },
    state: {
      required: false,
      hidden: true
    },
    phone: {
      hidden: true
    }
  },
  PR: {
    city: {
      label: 'Municipality'
    },
    state: {
      required: false,
      hidden: true
    },
    phone: {
      hidden: true
    }
  },
  PT: {
    state: {
      required: false,
      hidden: true
    },
    phone: {
      hidden: true
    }
  },
  PY: {
    state: {
      label: 'Department'
    },
    phone: {
      hidden: true
    }
  },
  RE: {
    state: {
      required: false,
      hidden: true
    },
    phone: {
      hidden: true
    }
  },
  RO: {
    state: {
      label: 'County',
      required: true
    },
    phone: {
      hidden: true
    }
  },
  RS: {
    city: {
      required: true
    },
    postcode: {
      required: true,
      type: 'number'
    },
    state: {
      label: 'District',
      required: false
    },
    phone: {
      hidden: true
    }
  },
  RW: {
    state: {
      required: false,
      hidden: true
    },
    phone: {
      hidden: true
    }
  },
  SG: {
    state: {
      required: false,
      hidden: true
    },
    city: {
      required: false
    },
    phone: {
      hidden: true
    }
  },
  SK: {
    postcode: {
      priority: 65,
      type: 'number'
    },
    state: {
      required: false,
      hidden: true
    },
    phone: {
      hidden: true
    }
  },
  SI: {
    postcode: {
      priority: 65,
      type: 'number'
    },
    state: {
      required: false,
      hidden: true
    },
    phone: {
      hidden: true
    }
  },
  SR: {
    postcode: {
      required: false,
      hidden: true,
      type: 'number'
    },
    phone: {
      hidden: true
    }
  },
  SV: {
    state: {
      label: 'Department'
    },
    phone: {
      hidden: true
    }
  },
  ES: {
    postcode: {
      priority: 65,
      type: 'number'
    },
    state: {
      label: 'Province'
    },
    phone: {
      hidden: true
    }
  },
  LI: {
    postcode: {
      priority: 65,
      type: 'number'
    },
    state: {
      required: false,
      hidden: true
    },
    phone: {
      hidden: true
    }
  },
  LU: {
    state: {
      required: false,
      hidden: true
    },
    phone: {
      hidden: true
    }
  },
  MD: {
    state: {
      label: 'Municipality / District'
    },
    phone: {
      hidden: true
    }
  },
  SE: {
    postcode: {
      priority: 65,
      type: 'number'
    },
    state: {
      required: false,
      hidden: true
    },
    phone: {
      hidden: true
    }
  },
  TR: {
    postcode: {
      priority: 65,
      type: 'number'
    },
    state: {
      label: 'Province'
    },
    phone: {
      hidden: true
    }
  },
  UG: {
    postcode: {
      required: false,
      hidden: true,
      type: 'number'
    },
    city: {
      label: 'Town / Village',
      required: true
    },
    state: {
      label: 'District',
      required: true
    },
    phone: {
      hidden: true
    }
  },
  US: {
    postcode: {
      label: 'ZIP Code',
      type: 'number'
    },
    state: {
      label: 'State'
    },
    phone: {
      hidden: false
    }
  },
  UY: {
    state: {
      label: 'Department'
    },
    phone: {
      hidden: true
    }
  },
  GB: {
    postcode: {
      label: 'Postcode',
      type: 'text'
    },
    state: {
      label: 'County',
      required: false
    },
    phone: {
      hidden: true
    }
  },
  ST: {
    postcode: {
      required: false,
      hidden: true,
      type: 'number'
    },
    state: {
      label: 'District'
    },
    phone: {
      hidden: true
    }
  },
  VN: {
    state: {
      required: false,
      hidden: true
    },
    postcode: {
      priority: 65,
      required: false,
      hidden: false,
      type: 'number'
    },
    address_2: {
      required: false,
      hidden: false
    },
    phone: {
      hidden: true
    }
  },
  WS: {
    postcode: {
      required: false,
      hidden: true,
      type: 'number'
    },
    phone: {
      hidden: true
    }
  },
  YT: {
    state: {
      required: false,
      hidden: true
    },
    phone: {
      hidden: true
    }
  },
  ZA: {
    state: {
      label: 'Province'
    },
    phone: {
      hidden: true
    }
  },
  ZW: {
    postcode: {
      required: false,
      hidden: true,
      type: 'number'
    },
    phone: {
      hidden: true
    }
  },
  default: {
    0: 'first_name',
    1: 'last_name',
    2: 'company',
    3: 'address_1',
    4: 'address_2',
    5: 'country',
    6: 'city',
    7: 'state',
    8: 'postcode',
    9: 'phone',
    first_name: {
      label: 'First Name',
      required: true,
      class: ['form-row-first'],
      autocomplete: 'given-name',
      priority: 10
    },
    last_name: {
      label: 'Last Name',
      required: true,
      class: ['form-row-last'],
      autocomplete: 'family-name',
      priority: 20
    },
    company: {
      label: 'Company Name',
      class: ['form-row-wide'],
      autocomplete: 'organization',
      priority: 30,
      required: false
    },
    country: {
      type: 'country',
      label: 'Country / Region',
      required: true,
      class: ['form-row-wide', 'address-field', 'update_totals_on_change'],
      autocomplete: 'country',
      priority: 40
    },
    address_1: {
      label: 'Street Address',
      required: true,
      class: {
        1: 'address-field'
      },
      autocomplete: 'address-line1',
      priority: 50
    },
    address_2: {
      label: 'Apt, Unit, Etc',
      label_class: [],
      class: {
        1: 'address-field'
      },
      autocomplete: 'address-line2',
      priority: 60,
      required: false
    },
    city: {
      label: 'Town / City',
      required: true,
      class: ['form-row-wide', 'address-field'],
      autocomplete: 'address-level2',
      priority: 70
    },
    state: {
      type: 'state',
      label: 'State / County',
      required: true,
      class: {
        1: 'address-field'
      },
      validate: ['state'],
      autocomplete: 'address-level1',
      priority: 80
    },
    postcode: {
      label: 'Postcode / ZIP',
      required: true,
      class: {
        1: 'address-field'
      },
      validate: ['postcode'],
      autocomplete: 'postal-code',
      priority: 90,
      type: 'number'
    },
    phone: {
      hidden: true
    }
  }
}
